import { render, staticRenderFns } from "./SkeletonLoading.vue?vue&type=template&id=56b8f222&scoped=true&"
import script from "./SkeletonLoading.vue?vue&type=script&lang=js&"
export * from "./SkeletonLoading.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonLoading.vue?vue&type=style&index=0&id=56b8f222&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b8f222",
  null
  
)

export default component.exports